import { ComponentPropsWithoutRef, FC, memo } from 'react';
import { Heading, SubTitle } from '../../../../landing.common/heading';
import { CreditProductType } from '../../../../../services/creditProduct/types';
import { useAutoSendProductData } from '../../../../../store/reducers/autoSendProduct';

import styles from './product.module.scss';

const ProductTypes = {
    [CreditProductType.CREDIT]: 'Кредит наличными',
    [CreditProductType.AUTO_CREDIT]: 'Автокредит',
    [CreditProductType.CREDIT_CARD]: 'Кредитная карта',
};

type Props = ComponentPropsWithoutRef<'div'>;

const ProductComponent: FC<Props> = (props) => {
    const { className } = props;
    const { product } = useAutoSendProductData();

    if (!product) {
        return null;
    }

    const productType = ProductTypes[product.type as keyof typeof ProductTypes] || '';

    return (
        <div className={className}>
            <Heading level={2} className={styles['title']}>
                {productType || ''} <br /> <span className={styles['title__product-name']}>{product.name || ''}</span>
            </Heading>
            <SubTitle className={styles['sub-title']}>Подайте заявку и получите решение банка за 1 день</SubTitle>
        </div>
    );
};

export const Product = memo(ProductComponent);
